import { render, staticRenderFns } from "./HollowDotsSpinner.vue?vue&type=template&id=537be8af&scoped=true"
import script from "./HollowDotsSpinner.vue?vue&type=script&lang=js"
export * from "./HollowDotsSpinner.vue?vue&type=script&lang=js"
import style0 from "./HollowDotsSpinner.vue?vue&type=style&index=0&id=537be8af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../vue-loader@15.11.1_babel-core@6.26.3_css-loader@4.3.0_lodash@4.17.21_prettier@1.19.1_vue-temp_lls4wxv5ipnxzldxaoogv2ybrq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537be8af",
  null
  
)

export default component.exports